const baseUrl = "/.netlify/functions/api";
//const baseUrl = "http://localhost:3002";

export default baseUrl;
